module.exports = __webpack_public_path__ + "5644da38b7905b671fa8cb12e6125eb4.pdf";